import { useQuery } from "react-query"
import {
  getPerformersPaged,
  PerformerSortBy,
  PerformerSortDir,
} from "@requests/performers"

export function usePerformersPaged(
  bandId: number,
  page: number,
  perPage = 50,
  search = "",
  sortBy?: PerformerSortBy,
  sortDir?: PerformerSortDir,
) {
  return useQuery(
    ["performers_paged", bandId, page, perPage, search, sortBy, sortDir],
    () => getPerformersPaged(bandId, page, perPage, search, sortBy, sortDir),
    { keepPreviousData: true },
  )
}
